import { useState, useEffect } from 'react';
import { getUrl, uploadData } from 'aws-amplify/storage';
import { fmtDur } from '../../platform/store/useOperationalStore';

export function tsToMs(ts) {
  if (!ts) return null;
  return ts < 10_000_000_000 ? ts * 1000 : ts;
}

export function fmtTs(ts) {
  const ms = tsToMs(ts);
  if (!ms) return '—';
  return new Date(ms).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true,
  });
}

export function fmtTime(ts) {
  const ms = tsToMs(ts);
  if (!ms) return '—';
  return new Date(ms).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

export function fmtAgo(ts, now) {
  const ms = tsToMs(ts);
  if (!ms) return null;
  return fmtDur(now - ms);
}

export function fmtDate(ts) {
  const ms = tsToMs(ts);
  if (!ms) return '—';
  return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// Strip __typename from objects before sending to AppSync mutations
export function clean(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(clean);
  const { __typename, ...rest } = obj;
  return Object.fromEntries(Object.entries(rest).map(([k, v]) => [k, clean(v)]));
}

export function makeActivityId() {
  return `act-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
}

// Parse legacy note strings (may be JSON or plain text)
export function parseLegacyText(text) {
  if (!text || typeof text !== 'string') return { text: text || '', photoKey: null };
  const t = text.replace(/^,/, '').trim();
  if (t.startsWith('{')) {
    try {
      const p = JSON.parse(t);
      return { text: String(p.text || '').trim(), photoKey: p.photoUrl || null };
    } catch {}
  }
  return { text: t, photoKey: null };
}

export function useS3Url(key) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!key) return;
    if (/^https?:\/\//i.test(key)) { setUrl(key); return; }
    const path = key.startsWith('public/') ? key : `public/${key}`;
    let cancelled = false;
    getUrl({ path }).then(({ url: u }) => { if (!cancelled) setUrl(u.toString()); }).catch(() => {});
    return () => { cancelled = true; };
  }, [key]);
  return url;
}

export async function uploadPhoto(file) {
  const ext = file.name.split('.').pop().toLowerCase();
  const key = `ro-photos/${Date.now()}-${Math.random().toString(36).slice(2, 7)}.${ext}`;
  await uploadData({ path: `public/${key}`, data: file }).result;
  return key;
}
